const component = "section-appliances-count-by-programming-category";

export const sectionAppliancesCountByProgrammingCategory = {
  component,
  categoryItem: `${component}/category-item`,
  applianceIcon: `${component}/appliance-icon`,
  applianceText: `${component}/appliance-text`,
};
